<template>
  <IconInfoCards :info-cards="characteristicsInfoCards" />
</template>

<script setup lang="ts">
import { sift } from "radash";
import { computed } from "vue";

import { useI18nMainSiteCompanyWall } from "@solvari/translations";

import IconInfoCards from "~/features/company-wall/components/company-wall-details/content/IconInfoCards.vue";

const props = defineProps<{
  characteristics: App.Data.CompanyWallCharacteristicsData;
}>();

const { tr } = useI18nMainSiteCompanyWall();

const characteristicsInfoCards = computed<
  { description: string; icon: string; title: string }[]
>(() => {
  const characteristics = props.characteristics;

  return sift([
    characteristics.checkedBySolvari
      ? {
          title: tr(
            "main_site.company_wall.characteristics.checked_by_solvari_title",
          ),
          description: tr(
            "main_site.company_wall.characteristics.checked_by_solvari",
          ),
          icon: "fa-regular fa-badge-check",
        }
      : null,
    {
      title: tr("main_site.company_wall.characteristics.since_title", {
        year: characteristics.partnerSince,
      }),
      description: tr("main_site.company_wall.characteristics.partner_since"),
      icon: "fa-regular fa-award",
    },
    characteristics.amountOfEmployees
      ? {
          title: characteristics.amountOfEmployees,
          description:
            characteristics.amountOfEmployees === "1"
              ? tr("main_site.company_wall.characteristics.employees_single")
              : tr("main_site.company_wall.characteristics.employees_plural"),
          icon: "fa-regular fa-users",
        }
      : null,
    characteristics.startupYear
      ? {
          title: tr("main_site.company_wall.characteristics.since_title", {
            year: characteristics.startupYear,
          }),
          description: tr(
            "main_site.company_wall.characteristics.startup_year",
          ),
          icon: "fa-regular fa-user-helmet-safety",
        }
      : null,
    characteristics.hasGuaranteeFund
      ? {
          title: tr("main_site.company_wall.characteristics.guarantee_fund"),
          description: tr(
            "main_site.company_wall.characteristics.guarantee_fund_description",
          ),
          icon: "fa-regular fa-shield-check",
        }
      : null,
    characteristics.yearsOfWarranty
      ? {
          title: tr(
            "main_site.company_wall.characteristics.years_of_warranty",
            { years: characteristics.yearsOfWarranty },
          ),
          description: tr("main_site.company_wall.characteristics.warranty_on"),
          icon: "fa-regular fa-shield-halved",
        }
      : null,
    characteristics.prePaymentPercentage
      ? {
          title: tr("main_site.company_wall.characteristics.uses_pre_payment"),
          description: tr(
            "main_site.company_wall.characteristics.uses_pre_payment_percentage",
            { percentage: characteristics.prePaymentPercentage },
          ),
          icon: "fa-regular fa-percent",
        }
      : null,
  ]);
});
</script>
